import { AdminsDTO } from "../../../api/Students/GetAdminsList";

const AdminsTable = ({ data }: { data?: AdminsDTO[] }) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    const hours = date.getHours() % 12 || 12;
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = date.getHours() >= 12 ? "PM" : "AM";

    return `${day}.${month}.${year} - ${hours}:${minutes} ${ampm}`;
  };

  return (
    <div>
      <div className="overflow-x-auto scrollbar-thumb-blue scrollbar-thumb-rounded scrollbar-track-blue-lighter scrollbar-w-2 scrolling-touch">
        <table className="table-auto w-full">
          <thead className="text-lg capitalize ">
            <tr className="bg-[#F1F4F9] rounded-t-lg">
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">ID</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Email</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">First Name</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Last Name</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Created At</div>
              </th>
            </tr>
          </thead>
          <tbody className="text-sm">
            {data?.map((admin: AdminsDTO) => (
              <tr>
                <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
                  <div className="inline-flex rounded-full text-left py-0.5 text-sm font-semibold">
                    {admin.id}
                  </div>
                </td>
                <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
                  <div className="inline-flex rounded-full text-left py-0.5 text-sm font-semibold">
                    {admin.email}
                  </div>
                </td>
                <td className=" px-2 first:pl-5 text-center last:pr-5  py-3 whitespace-nowrap">
                  <div className="inline-flex  rounded-full py-0.5 text-sm font-semibold">
                    {admin.firstName}
                  </div>
                </td>
                <td className=" px-2 first:pl-5 text-center last:pr-5  py-3 whitespace-nowrap">
                  <div className="inline-flex  rounded-full py-0.5 text-sm font-semibold">
                    {admin.lastName}
                  </div>
                </td>
                <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
                  <div className="inline-flex rounded-full text-left py-0.5 text-sm font-semibold">
                    {formatDate(admin.createdAt)}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminsTable;
